import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Prezentare generală marketing',
  tiles: {
    followers: 'Abonați',
    delivered_messages: 'Mesaje livrate',
    open_rate: 'Rată de deschidere',
    click_rate: 'Rată de clic',
    spam_report_rate: 'Rată de raportare spam',
    unsubscribe_rate: 'Rată de dezabonare',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Sursa abonamentului',
      count: 'Număr',
      percentage: 'Procent',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Șablon',
      delivered: 'Livrate',
      open_rate: 'Rată de deschidere',
      click_rate: 'Rată de clic',
      spam_report_rate: 'Rată de raportare spam',
      unsubscribe_rate: 'Rată de dezabonare',
    },
  },
  labels: {
    no_data: 'Fără date',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
  },
};
